import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ApiService } from 'src/app/services/api.service';
import * as vo from 'src/app/core/model/server/vo/_index';

@Injectable({
  providedIn: 'root',
})
export class RebateService {

  readonly providerOptions: { label: string; value: number }[] = [
    { label: 'Smart',         value: 1 },
    { label: 'Globe',         value: 2 },
    { label: 'Sun',           value: 3 },
    { label: 'TNT',           value: 4 },
    { label: 'Smart Bro',     value: 5 },
    // { label: 'Kuryente Load', value: 6 },
    { label: 'Cignal',        value: 7 },
    { label: 'DITO',          value: 8 },
    { label: 'TM',          value: 9 },
    { label: 'SatLite',          value: 10 },
    { label: 'Cignal Play TV',   value: 11 },
    { label: 'Cignal HD Kit',    value: 12 },
  ];

  readonly statusOptions: { label: string; value: boolean }[] = [
    { label: 'Enabled',  value: true  },
    { label: 'Disabled', value: false },
  ];

  // ─── Cached tier list (populated on first load, reused in dialogs) ─────────
  tierOptions: { label: string; value: number }[] = [];

  constructor(private apiService: ApiService) {}

  // ─── Helpers ──────────────────────────────────────────────────────────────

  getProviderLabel(providerType: number): string {
    return this.providerOptions.find(p => p.value === providerType)?.label
      ?? `Provider ${providerType}`;
  }

  // ─── API wrappers ─────────────────────────────────────────────────────────

  getTierOptions(): Observable<{ label: string; value: number }[]> {
    return this.apiService.getAccountsTiers().pipe(
      map((res: any) => {
        if (!res?.result) { 
          return [];
        }
        return res.result.map((t: any) => ({
          label: `Tier ${t.tierId} (${t.tierName})`,
          value: t.tierId,
        }));
      }),
      tap((options) => {
        this.tierOptions = options;  
      }),
    );
  }

  getRebatesByTier(tierId: number): Observable<any[]> {
    return this.apiService.getRebateByTier(tierId).pipe(
      map((res: any) => {
        if (!res?.result) {
          return [];
        }
        const raw = Array.isArray(res.result) ? res.result : [res.result];
        return raw.map((r: any) => ({
          ...r,
          isEnabled: r.deleteUser === null && r.deleteDate === null,
        }));
      }),
    );
  }

  createRebate(request: vo.CreateBuyloadRebateRequest): Observable<any> {
    return this.apiService.createBuyloadRebate(request);
  }

  updateRebate(request: vo.UpdateBuyloadRebateRequest, tierId: number): Observable<any> {
    return this.apiService.updateBuyloadRebate(request, tierId);
  }

  getDistributorsRebates(): Observable<vo.GetDistributorsRebatesResponse> {
    return this.apiService.getDistributorsRebates().pipe(
      map((res: any) => res?.result ?? res)
    );
  }

  modifyDistributorRebates(request: vo.EditDistributorRebateRequest): Observable<vo.BaseResponse> {
    return this.apiService.modifyDistributorRebates(request);
  }

  toggleRebateStatus(item: any, tierId: number, enable: boolean): Observable<any> {
    const request: vo.UpdateBuyloadRebateRequest = {
      providerType:     item.providerType,
      rebatePercentage: item.rebatePercentage,
      isEnabled:        enable,
    };
    return this.apiService.updateBuyloadRebate(request, tierId);
  }
}
